import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button, Select} from "antd";
import styled from "styled-components";
import Swal from "sweetalert2";

import FormControl from "../../component/form/FormControl";
import MasterService from '../../service/_Master';
import service from '../../service/Mgt-sensor';

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

const { Option } = Select;

const FormExtend = styled(FormControl)`
    .form-button{
    padding-left: 0;
    padding-right: 0;
    }

    .form-station-id{
        width: 100%;
    }
`;

export default function FormMgtSensor(props) {

    const [form] = Form.useForm();
    const [stations, setStations] = useState([])

    useEffect(() => {
        const InitData = async () => {
            setStations(await MasterService.getMasterStationByOrgId())
            if(props.sensorId){
                let formData = await service.getDetail(props.sensorId)
                form.setFieldsValue( formData ? {
                    name : formData.name,
                    dispName : formData.disp_name,
                    stationId : formData.station_id ,
                    allowPublic : formData.allow_public ? 1 : 0 ,
                    status : formData.status ? 1 : 0 ,
                    timeToYellow : formData.time_to_yellow,
                    timeToRed : formData.time_to_red,
                } : {})
            }
        }
        InitData()
    }, [form, props.sensorId])

    const onFinish = async (values) => {
        if(props.sensorId){
          let result = await service.update(props.sensorId, values)
          if(result){
            Swal.fire({
                title: "อัพเดทเซนเซอร์สำเร็จ",
                icon: "success",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 1500
            }).then(function() {
                  window.location.href = `/mgt-sensor`
            })
          }
        }else{
          let result = await service.create(values)
            if(result){
                Swal.fire({
                  title: "สร้างเซนเซอร์สำเร็จ",
                  icon: "success",
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                    window.location.href = `/mgt-sensor`
                })
            }
      }}

    const formInput = () => {
        return (
            <>
                <Form.Item
                    name={["stationId"]}
                    className="form-station-id"
                    label="สถานี"
                    rules={[{ required: true }]}
                >
                    <Select placeholder="กรุณาเลือก" allowClear>
                        {stations.map((item) =>( <Option key={item.id} value={item.id}>{item.name_th}</Option>))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={["name"]}
                    className="form-item__name"
                    label="ชื่อเซนเซอร์"
                    rules={[{ required: true }]}
                >
                    <Input autoComplete="off"/>
                </Form.Item>
                <Form.Item
                    name={["dispName"]}
                    className="form-item__disp-name"
                    label="ชื่อที่ใช้แสดง"
                    rules={[{ required: true }]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name={["timeToYellow"]}
                    className="form-item__timeToYellow"
                    label="จำนวนนาทีที่ขาดการเชื่อมต่อ(สีเหลือง)"
                    rules={[{ required: true }]}
                >
                    <Input autoComplete="off" placeholder="นาที" onChange={(e) => {
                        let value = e.target.value.replace(/[^0-9.]+/g, "");
                        form.setFieldsValue({ timeToYellow: value });
                    }}/>
                </Form.Item>
                <Form.Item
                    name={["timeToRed"]}
                    className="form-item__timeToRed"
                    label="จำนวนนาทีที่ขาดการเชื่อมต่อ(สีแดง)"
                    rules={[{ required: true }]}
                >
                    <Input autoComplete="off" placeholder="นาที" onChange={(e) => {
                        let value = e.target.value.replace(/[^0-9.]+/g, "");
                        form.setFieldsValue({ timeToRed: value });
                    }}/>
                </Form.Item>  
                <Form.Item
                    name={["allowPublic"]}
                    className="form-item__allowPublic"
                    label="การอนุญาตให้มองเห็นเซนเซอร์"
                    rules={[{ required: true }]}
                >
                    <Select placeholder="กรุณาเลือก" allowClear>
                        <Option value={1}>เปิดสาธารณะ</Option>
                        <Option value={0}>ปิดสาธารณะ</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name={["status"]}
                    className="form-item__status"
                    label="สถานะของเซนเซอร์"
                    rules={[{ required: true }]}
                >
                    <Select placeholder="กรุณาเลือก" allowClear>
                        <Option value={1}>เปิดใช้งาน</Option>
                        <Option value={0}>ปิดใช้งาน</Option>
                    </Select>
                </Form.Item>      
                <Form.Item className="form-button">
                {props.sensorId ? 
                (props.permission.indexOf('update') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">อัพเดทเซนเซอร์</Button>) : (<></>))
                : 
                (props.permission.indexOf('create') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">สร้างเซนเซอร์</Button>) : (<></>))}
                <Button className="form-item__btn-cancel btn-secondary"><Link to="/mgt-sensor"> ยกเลิก</Link></Button>
                </Form.Item>
            </>
        )
    };

    return (
        <FormExtend
            name={"form-add-sensor"}
            column={2}
            inputs={formInput}
            onFinish={props.onFinish ? props.onFinish : onFinish}
            form={form}
            className={props.className ? props.className : ""}
        ></FormExtend>
    );
}
